export default __webpack_public_path__ + "static/media/small-tree.f4e88099.jpeg";